module.exports = __webpack_public_path__ + "static/img/chanta (15).c109949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (15).jpg
// module id = jj4C
// module chunks = 0